import axios from 'axios';

const createApi = base => {
	return axios.create({
		baseURL: base
	});
}

export default createApi;
